import React from 'react';

import { logger as LOG } from '@garnish/logger';
import { useActor } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';
import { AuthModel } from '../AuthMachine.model';

// ────────────────────────────────────────────────────────────────────────────────
const logger = LOG.extend('AUTH');
// LOG.enable('AUTH');
// ────────────────────────────────────────────────────────────────────────────────

export const useSendLogoutToAuthMachine = () => {
  const { authMachineRef } = useEssentialMachines();
  const authMachine = useActor(authMachineRef);
  const { 1: send } = authMachine;

  const sendLogoutAction = React.useCallback(
    (csrf?: string) => {
      logger.debug('sending LOGOUT event to AuthMachine', csrf);
      send(AuthModel.events.LOGOUT(csrf));
    },
    [send],
  );

  return sendLogoutAction;
};
